import policePursuitBackgroundImage from "./assets/games/police_pursuit/backGround1.png";
import policePursuitIcon from "./assets/games/police_pursuit/icon.png";
import policePursuitIconFull from "./assets/games/police_pursuit/icon_full.png";

// import backgroundImg2 from "./assets/backGround2.png";
import backgroundImg3 from "./assets/backGround3.jpg";
import backgroundImg4 from "./assets/backGround4.jpg";
// home slide images
import catSimulatorBackgroundImage from "./assets/games/cat_simulator/backGround2.png";
import catSimulatorIcon from "./assets/games/cat_simulator/icon.png";
import catSimulatorIconFull from "./assets/games/cat_simulator/icon_full.png";

// import gameImg2 from "./assets/game2Img.png";
import gameImg3 from "./assets/game3Img.png";
import gameImg4 from "./assets/game2Img.png";
// home our game images
import homegameImg1 from "./assets/game1.png";
import homegameImg2 from "./assets/game2.png";
import homegameImg3 from "./assets/game3.png";
import homegameImg4 from "./assets/game4.png";
// game detail imgages
import gameDetailImg1 from "./assets/gameDetailImg1.jpg";
import gameDetailImg2 from "./assets/gameDetailBanner2.jpg";
import gameSliderImg1 from "./assets/game1.png";
import gameSliderImg2 from "./assets/game2.png";
import gameSliderImg3 from "./assets/game3.png";
import gameSliderImg4 from "./assets/game4.png";
// our story page tema images

import memberImg1 from "./assets/000001.png";
import memberImg2 from "./assets/000002.png";
import memberImg3 from "./assets/000003.png";
import memberImg4 from "./assets/000004.png";
import memberImg5 from "./assets/000029.png";
// news feed images

import newsImg1 from "./assets/news1.jpg";
import newsImg2 from "./assets/news2.jpg";
import { TwitterSquareFilled } from "@ant-design/icons";

export const HeaderNavItems = [
  {
    pageName: "home",
    path: "/",
  },
  {
    pageName: "games",
    path: "/games",
  },
  {
    pageName: "Our Story",
    path: "/about-us",
  },
  {
    pageName: "News",
    path: "/news",
  },
  {
    pageName: "Support",
    path: "/support",
  },
  {
    pageName: "Contact",
    path: "/contact",
  },
];

export const HomeSliderData = [
  {
    title: "Police Pursuit",
    desc: "Experience heart-pounding action as you take control of a daring getaway driver in this thrilling car racing adventure.",
    backGroundImg: policePursuitBackgroundImage,
    gameImg: policePursuitIcon,
  },
  {
    title: "Cat Simulator",
    desc: "Embark on a mischievous feline adventure! Play as a clever cat, explore Grandma’s house, and cause playful chaos in this fun and cozy game",
    backGroundImg: catSimulatorBackgroundImage,
    gameImg: catSimulatorIcon,
  },
];
// home games

export const HomeGamesData = [
  {
    id: "1",
    gameDesc: "Police Pursuit",
    gameImg: policePursuitIconFull,
    anroidLink:
      "https://play.google.com/store/apps/details?id=com.shiftedpixel.police.pursuit",
    appleLink:
      "https://apps.apple.com/us/app/police-car-chase-police-games/id6739004227",
    detail: "- Drift the car as your life depends on it.",
    detail1: "- Shake off the police on your tail",
    // detail2: "- Collect coins to unlock fancy cars",
    detail2:
      "- While playing Police Car Chase, spam or unknown calls can interrupt gameplay and break focus. <a href='https://thetruecaler.com/'>Truecaller MOD APK</a> helps identify unknown callers and block spam on Android, so gameplay remains uninterrupted",
    detailBannerImg: [
      {
        bannerImg: gameDetailImg1,
      },
      {
        bannerImg: gameDetailImg2,
      },
    ],
    sliderImages: [
      {
        img: gameSliderImg1,
      },
      {
        img: gameSliderImg2,
      },
      {
        img: gameSliderImg3,
      },
      {
        img: gameSliderImg4,
      },
    ],
    developers: [
      {
        developer: "ShiftedPixel Games",
      },
      {
        developer: "Faizan Qureshi, Usman Nawaz",
      },
    ],
    publisher: [
      {
        publisher: "ShiftedPixel Games",
      },
    ],
    platForms: [
      {
        platForm: "iOS",
      },
      {
        platForm: "Android",
      },
    ],
    gameLanguages: [
      {
        gameLanguage: "EN",
      },
      {
        gameLanguage: "RU",
      },
      {
        gameLanguage: "CN",
      },
      {
        gameLanguage: "GP",
      },
      {
        gameLanguage: "PR",
      },
      {
        gameLanguage: "ES",
      },
      {
        gameLanguage: "FR",
      },
      {
        gameLanguage: "DE",
      },
    ],
    gameWebsiteLink: "",
    gameVideoLink: "https://www.youtube.com/shorts/GdR2DuX6JMw",
  },
  {
    id: "2",
    gameDesc: "Cat Simulator",
    gameImg: catSimulatorIconFull,
    anroidLink: "",
    appleLink:
      "https://apps.apple.com/us/app/whisker-quest-furry-adventure/id6743572722",
    detail: "Step into the paws of a curious and mischievous cat.",
    detail1: "Grandma’s house is your playground.",
    detail2:
      "Dress up your furry troublemaker with adorable outfits and accessories.",
    detailBannerImg: [
      {
        bannerImg: gameDetailImg1,
      },
      {
        bannerImg: gameDetailImg2,
      },
    ],
    sliderImages: [
      {
        img: gameSliderImg1,
      },
      {
        img: gameSliderImg2,
      },
      {
        img: gameSliderImg3,
      },
      {
        img: gameSliderImg4,
      },
    ],
    developers: [
      {
        developer: "Usman Nawaz",
      },
      {
        developer: "Faizan Qureshi",
      },
    ],
    publisher: [
      {
        publisher: "ShiftedPixel Games",
      },
    ],
    platForms: [
      {
        platForm: "iOS",
      },
      // {
      //   platForm: "Android",
      // },
    ],
    gameLanguages: [
      {
        gameLanguage: "EN",
      },
      {
        gameLanguage: "RU",
      },
      {
        gameLanguage: "CN",
      },
      {
        gameLanguage: "GP",
      },
      {
        gameLanguage: "PR",
      },
      {
        gameLanguage: "ES",
      },
      {
        gameLanguage: "FR",
      },
      {
        gameLanguage: "DE",
      },
    ],
    gameWebsiteLink: "https://carmechanicsimulatormobile.digitalmelody.eu/",
    gameVideoLink: "",
  },
];
// home about us

export const HomeAboutUsData = [
  {
    date: "9th Jan, 2025",
    desc: 'Made a debut by releasing our first game "Police Pursuit" on App Store ',
    extra: "#game_Release",
  },
  {
    date: "7th Mar,2025",
    desc: "Police Pursuit made it's way to Google Play Store",
    extra: "#GAME_RELEASE",
  },
  {
    date: "22nd March, 2025",
    desc: 'Released our second highly anticipated game "Cat Simulator" on App Store',
    extra: "#GAME_RELEASE",
  },
];

// our story page team sections
export const OurStoryTeam = [
  {
    profileImg: memberImg1,
    name: "Waqas Younis",
    designation: "Co-founder, Advisor",
  },
  {
    profileImg: memberImg2,
    name: "Usman Nawaz",
    designation: "Co-founder, CEO",
  },
  {
    profileImg: memberImg3,
    name: "Muhammad Umair",
    designation: "Unity3D Game Developer",
  },
  {
    profileImg: memberImg4,
    name: "Umaima Sameen",
    designation: "Game Designer",
  },
  {
    profileImg: memberImg5,
    name: "Muhammad Awais Ali",
    designation: "Designer",
  },
  {
    profileImg: memberImg1,
    name: "Ehsan Khadim",
    designation: "Unity3D Game Developer",
  },
  {
    profileImg: memberImg2,
    name: "Ali Abit",
    designation: "3D Artist",
  },
  {
    profileImg: memberImg2,
    name: "Mansab",
    designation: "ASO Expert",
  },
];

// news feed card data

export const NewsFeedData = [
  // {
  //   newsImg: newsImg1,
  //   date: "22 Jan 2009",
  //   icon: <TwitterSquareFilled />,
  //   newsDesc:
  //     "Get ready for the ultimate lumberjack showdown in Timberman 2 - VS Battle! Grab your axe, build your village, and compete for the title of the world's best lumberjack! #Timberman2",
  // },
  // {
  //   newsImg: newsImg2,
  //   date: "22 Jan 2019",
  //   icon: <TwitterSquareFilled />,
  //   newsDesc:
  //     "Ready to become the car trading king? Dive into Car Sale Simulator 2023, where you can sell, buy, haggle, and rake in the cash!",
  // },
  // {
  //   newsImg: newsImg1,
  //   date: "22 Jan 2009",
  //   icon: <TwitterSquareFilled />,
  //   newsDesc:
  //     "Get ready for the ultimate lumberjack showdown in Timberman 2 - VS Battle! Grab your axe, build your village, and compete for the title of the world's best lumberjack! #Timberman2",
  // },
  // {
  //   newsImg: newsImg2,
  //   date: "22 Jan 2019",
  //   icon: <TwitterSquareFilled />,
  //   newsDesc:
  //     "Ready to become the car trading king? Dive into Car Sale Simulator 2023, where you can sell, buy, haggle, and rake in the cash!",
  // },
  // {
  //   newsImg: newsImg1,
  //   date: "22 Jan 2009",
  //   icon: <TwitterSquareFilled />,
  //   newsDesc:
  //     "Get ready for the ultimate lumberjack showdown in Timberman 2 - VS Battle! Grab your axe, build your village, and compete for the title of the world's best lumberjack! #Timberman2",
  // },
  // {
  //   newsImg: newsImg2,
  //   date: "22 Jan 2019",
  //   icon: <TwitterSquareFilled />,
  //   newsDesc:
  //     "Ready to become the car trading king? Dive into Car Sale Simulator 2023, where you can sell, buy, haggle, and rake in the cash!",
  // },
];
